// extracted by css-extract-rspack-plugin
export default {"root":"root-XnLT8u"};